import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useDealerProvider } from '../Dealer.Hooks';

export default function DealerDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useDealerProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={deleteApi.execute}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.displayInfo.title}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
